import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@mui/material';
import { IModalProps } from 'components/Modal';
import useServiceChange from 'hooks/useServiceChange';

import { StyledGradeBookTisModal, StyledGradeBookTisModalPaper } from './styled';

interface PropsType extends Omit<IModalProps, 'children' | 'title'> {}

function GradeBookLessonInfoTisModal({ ...props }: PropsType) {
	const { t } = useTranslation();
	const serviceChange = useServiceChange();

	const handleServiceChange = () => {
		serviceChange(3);
	};

	return (
		<StyledGradeBookTisModal
			title="TIS"
			actions={
				<Button variant="contained" onClick={handleServiceChange}>
					{t('gradeBook.tisChangeButton')}
				</Button>
			}
			{...props}
		>
			<StyledGradeBookTisModalPaper>
				<Typography>{t('gradeBook.tisChange')}</Typography>
			</StyledGradeBookTisModalPaper>
		</StyledGradeBookTisModal>
	);
}

export default GradeBookLessonInfoTisModal;
